import React from 'react';
import { IconButton } from '@mui/material';
import { TableItemActionsNew, Icons } from 'components';
const columns = (postDefault, copyItem, formatCardNumber, actionsList, currentLoaction, handleOnEdit, setItemIdToDelete, setConfirmDeleteModal) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'پیش فرض',
    field: 'default',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => (
      <IconButton
        style={{ padding: 4 }}
        onClick={() => (!row?.default ? postDefault(row?.id) : null)}
        size="large">

        {row?.default ? (
          <Icons icon="Accept" color="#303d8f" size="25" />

        ) : (
          <Icons icon="Accept" color="#d1d8dc" size="25" />

        )}
      </IconButton>
    ),
  },
  {
    title: 'شماره کارت',
    field: 'number',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => {

      if (rd?.number) {
        return (
          <>
            <span
              style={{
                marginInlineEnd: 8,
                position: 'relative',
                top: 4,
                cursor: 'pointer',

              }}
              onClick={() => copyItem(rd?.number)}
            >
              <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
            </span>
            <span
              style={{
                unicodeBidi: 'embed',
                direction: 'ltr',
              }}
            >
              {formatCardNumber(rd?.number)}
            </span>

          </>
        );
      } else {
        return '-';
      }
    },
  },
  {
    title: 'عنوان حساب',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'name',
  },
  {
    title: 'نام صاحب حساب',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'ownerNameInquiry',
  },

  ...((String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? (actionsList['cardsImprestDeleteCardPage'] || actionsList['cardsImprestUpdateCardPage']) : (actionsList['cardsDeleteCardPage'] || actionsList['cardsUpdateCardPage'])) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
          title=""
          otherMenus={[
            {
              title: 'ویرایش ',
              isShow: !!(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['cardsImprestUpdateCardPage'] : actionsList['cardsUpdateCardPage']),
              onClick: () => {
                handleOnEdit(rowData);
              },
            },
            {
              title: 'حذف ',
              isShow: !!(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['cardsImprestDeleteCardPage'] : actionsList['cardsDeleteCardPage']),
              onClick: () => {
                setItemIdToDelete(rowData?.id);
                setConfirmDeleteModal(true);
              },
            },


          ]}
        />
      ),
    }] : []),

];

const status = {
  MULTI_CONFIRMATION_VERIFY_TOOL_SMS: 'پیامک',
  MULTI_CONFIRMATION_VERIFY_TOOL_API: 'سرویس',
};
const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
